import { render, staticRenderFns } from "./TemplateImageEditor.vue?vue&type=template&id=4b03b83c"
import script from "./TemplateImageEditor.vue?vue&type=script&lang=js"
export * from "./TemplateImageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports